<template>
    <div class="spread_page">
        <div class="spread_top_1">
            <!-- logo -->
            <div class="spread_top_logo">
                <img src="@/assets/img/spread/logo.png" alt="logo" />
            </div>

            <!-- 点 -->
            <div class="spread_top_1_point">
                <img src="@/assets/img/spread/point.png" alt="point" />
            </div>
        </div>

        <div class="spread_top_2">
            <!-- 横幅 -->
            <div class="spread_top_2_text">
                <img src="@/assets/img/spread/text.png" alt="text" />
            </div>

            <!-- 列表 -->
            <div class="spread_top_2_threeBody">
                <dl>
                    <dt><img src="@/assets/img/spread/tv.png" alt="tv"></dt>
                    <dd>高手操盘</dd>
                </dl>
                <dl>
                    <dt><img src="@/assets/img/spread/robot.png" alt="robot"></dt>
                    <dd>智能选股</dd>
                </dl>
                <dl>
                    <dt><img src="@/assets/img/spread/new.png" alt="new"></dt>
                    <dd>股市资讯</dd>
                </dl>
            </div>
        </div>

        <div class="spread_top_3">
            <!-- 下载 -->
            <div @click="toDownloadApp" class="spread_top_3_download">
                <img src="@/assets/img/spread/download.png" alt="download">
            </div>
        </div>

        <div class="spread_top_4">
            <div class="spread_top_4_1">
                <div class="spread_top_4_1_title">
                    <em></em>
                    <span>产品介绍</span>
                    <em></em>
                </div>
    
                <div class="spread_top_4_1_text">
                    <p>爱股票，专业股市投资者社区，汇聚股市高手，分享实战选股策略、股票投资组合、实时行情、资讯研报等服务，已涵盖A股/港股/基金/美股/等领域，拥有超百万高端用户。</p>
                </div>
    
                <div class="spread_top_4_1_banner">
                    <img src="@/assets/img/spread/01_img.png" alt="img_01">
                </div>
            </div>

            <div class="spread_top_4_2">
                <img src="@/assets/img/spread/semicircle.png" alt="semicircle">
            </div>

            <div class="spread_top_4_3">
                <div class="spread_top_4_3_title">
                    <em></em>
                    <span>产品功能</span>
                    <em></em>
                </div>
                <div class="spread_top_4_3_1">
                    <div class="spread_top_4_3_1_count">
                        <span>社区</span>
                    </div>
                    <div class="spread_top_4_3_1_text">
                        <p>与股市专家和实战高手同台交流，盘中实时分享选股思路，指点市场方向，并实时答疑解惑。</p>
                    </div>
                    <div class="spread_top_4_3_1_img">
                        <img src="@/assets/img/spread/02_img.png" alt="img_02">
                    </div>
                </div>
                <div class="spread_top_4_3_1_line"></div>
                <div class="spread_top_4_3_1">
                    <div class="spread_top_4_3_1_count spread_top_4_3_2_count">
                        <span>组合</span>
                    </div>
                    <div class="spread_top_4_3_1_text">
                        <p>查看实战高手（智能投顾）投资组合和调仓记录，跟实战高手同步，让智能大数据帮你选牛股。</p>
                    </div>
                    <div class="spread_top_4_3_1_img spread_top_4_3_2_img">
                        <img src="@/assets/img/spread/03_img.png" alt="img_03">
                    </div>
                </div>
            </div>
        </div>

        <div class="spread_top_5">
            <p>市场有风险，投资需谨慎。从事证券投资或期货交易，请通过合法证券期货经营机构进行，合法机构名单可到中国证监会网站（http://www.csrc.gov.cn）查询。</p>
            <p>福建中讯证券研究有限责任公司业务资格许可证号913501057099036881，闽ICP备15016652号-3，中讯证券研究有限责任公司版权所有，北京亿客科创信息技术有限公司提供技术支持</p>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "Spread",
    components: {},
    data() {
        return {
            downloadAppUrl: "http://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui",
        };
    },
    created() {
        //
    },
    mounted() {
        //
    },
    methods: {
        // 跳转下载链接
        toDownloadApp() {
            location.href = this.downloadAppUrl;
        },
    },
};
</script>
  
<style scoped lang="scss">
.spread_page {
    position: relative;
    padding: 9px 0 23px;
    background-color: #DA1A20;
    min-height: 100vh;
    box-sizing: border-box;

    .spread_top_1 {
        width: 100%;
        box-sizing: border-box;
        padding: 0 7.5px 0 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 10.5px;

        .spread_top_logo {
            margin-top: 16.5px;
            height: 33px;
            width: auto;
            
            img {
                height: 100%;
                width: auto;
                display: block;
            }
        }

        .spread_top_1_point {
            height: 58.5px;
            width: auto;

            img {
                height: 100%;
                width: auto;
                display: block;
            }
        }
    }

    .spread_top_2 {
        width: 100%;
        height: auto;
        background-image: url("../../assets/img/spread/arrow.png");
        background-size: auto 75.5px;
        background-repeat: no-repeat;
        background-position-y: 57px;
        margin-bottom: 25.5px;

        .spread_top_2_text {
            height: 55.5px;
            width: auto;
            margin-bottom: 40.5px;

            img {
                height: 100%;
                width: auto;
                display: block;
                margin: 0 auto;
            }
        }

        .spread_top_2_threeBody {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 0 57px 0;

            dl {
                text-align: center;

                dt{
                    width: 30px;
                    height: 30px;
                    margin: 0 auto 8px;
                    img{
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }

                dd {
                    font-size: 14px;
                    line-height: 18px;
                    color: rgb(255, 255, 188);
                }
            }
        }
    }

    .spread_top_3 {
        width: 100%;
        height: 86px;
        background-image: url("../../assets/img/spread/wave.png");
        background-size: 100% auto;
        background-position-y: bottom;
        background-repeat: no-repeat;

        .spread_top_3_download {
            height: 60px;
            width: auto;

            img {
                height: 100%;
                width: auto;
                display: block;
                margin: 0 auto;
            }
        }
    }

    .spread_top_4 {
        padding: 0 12px;
        box-sizing: border-box;
        margin-bottom: 14px;

        .spread_top_4_1 {
            width: 100%;
            height: auto;
            border-radius: 10px;
            background-color: #FFE4D8;
            padding: 17px 16.5px 22.5px;
            box-sizing: border-box;
            position: relative;
            z-index: 2;

            .spread_top_4_1_title {
                width: 100%;
                height: 20.5px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                margin-bottom: 15.5px;;

                span {
                    font-size: 18px;
                    line-height: 20.5px;
                    color: #D71A1F;
                    font-weight: bold;
                    margin: 0 8.5px;
                }

                em {
                    width: 11px;
                    height: 11px;
                    background-color: #D91512;
                    transform: rotate(45deg);
                }
            }

            .spread_top_4_1_text {
                width: 100%;
                height: auto;
                margin-bottom: 11.5px;
                
                p {
                    font-size: 15px;
                    line-height: 22.5px;
                    color: #8B1C20;
                }
            }

            .spread_top_4_1_banner {
                width: 218px;
                height: auto;
                margin: 0 auto;

                img {
                    width: 100%;
                    height: auto;
                    display: block;
                }
            }
        }

        .spread_top_4_2 {
            height: 25.5px;
            width: 100%;
            position: relative;
            z-index: 1;

            img {
                width: 137.5px;
                height: auto;
                display: block;
                position: absolute;
                right: -12px;
                top: -40px;
            }
        }

        .spread_top_4_3 {
            width: 100%;
            height: auto;
            border-radius: 10px;
            background-color: #FFE4D8;
            padding: 17px 21px 36.5px;
            box-sizing: border-box;
            position: relative;
            z-index: 2;

            .spread_top_4_3_title {
                width: 100%;
                height: 20.5px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                margin-bottom: 15.5px;;

                span {
                    font-size: 18px;
                    line-height: 20.5px;
                    color: #D71A1F;
                    font-weight: bold;
                    margin: 0 8.5px;
                }

                em {
                    width: 11px;
                    height: 11px;
                    background-color: #D91512;
                    transform: rotate(45deg);
                }
            }

            .spread_top_4_3_1 {
                width: 100%;
                height: auto;

                .spread_top_4_3_1_count {
                    width: 60px;
                    height: 60.54px;
                    background-image: url("../../assets/img/spread/01.png");
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    text-align: right;
                    padding-top: 30.5px;
                    box-sizing: border-box;
                    margin-bottom: 2px;

                    &.spread_top_4_3_2_count {
                        background-image: url("../../assets/img/spread/02.png");
                    }

                    span {
                        font-size: 17px;
                        line-height: 20.5px;
                        color: #8D1B1C;
                        font-weight: bold;
                    }
                }

                .spread_top_4_3_1_text {
                    width: 100%;
                    height: auto;
                    margin-bottom: 22px;

                    p {
                        font-size: 14px;
                        line-height: 20px;
                        color: #8D1B1C;
                    }
                }

                .spread_top_4_3_1_img {
                    width: 286px;
                    height: auto;
                    margin: 0 auto;

                    img {
                        width: 100%;
                        height: auto;
                        display: block;
                    }
                }
            }

            .spread_top_4_3_1_line {
                margin-top: 38.5px;
                width: 100%;
                height: 0;
                border-bottom: 1px dashed #FFCAB6;
                margin-bottom: 23.5px;
            }
        }
    }

    .spread_top_5 {
        height: auto;
        margin: 0 12px;
        box-sizing: border-box;
        padding: 9px 12px 13px 13px;
        border-radius: 10px;
        border: 0.5px solid #DF8B8B;

        p {
            font-size: 12px;
            line-height: 15.5px;
            color: #F6ACAD;
        }
    }
}
</style>